import React from "react";
import "./PortfolioLeaders.css";

import bretFund from "../../../images/bret-fund.png";
import shamsahNoorani from "../../../images/shamsah-noorani.png";
import hawamaSattar from "../../../images/hawama-sattar.png";

function PortfolioLeaders() {
  const leaders = [
    {
      image: bretFund,
      name: "Bret Fund",
      role: "Chief Executive Officer (CEO)",
      bio: "Bret Fund is a visionary leader and seasoned executive with over two decades of experience in education technology, workforce development, and enterprise innovation. As CEO of EdTech Ventures, he oversees the firm's strategic vision, portfolio operations, and capital deployment across transformative skills-based learning and AI talent companies."
    },
    {
      image: shamsahNoorani,
      name: "Shamsah Noorani",
      role: "Chief Executive Officer (CEO)",
      bio: "Shamsah Noorani, CEO of Health Tech Academy, is a distinguished Global Sales and Marketing Executive with over 15 years of experience. Shamsah excels in Sales, Marketing, Partnerships, and building high-performance teams. She has a strong background in Technology (SaaS), Human Resources, and eLearning."
    },
    {
      image: hawamaSattar,
      name: "Dr. Hawama Sattar",
      role: "Program Expert",
      bio: "Hawama Sattar is a global sales and marketing executive with 20+ years of experience in enterprise sales, client retention, and revenue growth in healthcare and education technology. As VP at HealthTech Academy, she oversees 50+ university partnerships and leads a team of 25+ professionals."
    }
  ];

  return (
    <section className="portfolio-leaders py-5">
      <div className="container">

        {/* Heading */}
        <div className="text-center mb-5">
          <h2 className="pfLeader-title mb-2">
            Our Portfolio Leaders
          </h2>

          <div className="portfolio-divider"></div>
        </div>

        {/* Cards */}
        <div className="row g-4">

          {leaders.map((leader, index) => (
            <div
              key={index}
              className="col-lg-4 col-md-6 d-flex"
            >
              <div className="leader-card h-100 w-100">

                <img
                  src={leader.image}
                  alt={leader.name}
                  className="leader-image"
                />

                <div className="p-4">

                  <h3 className="leader-name mb-1">
                    {leader.name}
                  </h3>

                  <p className="leader-role mb-3">
                    ● {leader.role}
                  </p>

                  <p className="leader-bio mb-0">
                    {leader.bio}
                  </p>

                </div>

              </div>
            </div>
          ))}

        </div>

      </div>
    </section>
  );
}

export default PortfolioLeaders;